import whiteLabelMap from '@/configuration/sources/WhiteLabelsConfig.yml'

import {
  getFieldsProperties,
  getContentLabelFields,
  getI18nProperties
} from '@/store/utils/labels'
import {
  fieldStyle,
  getCssVariables,
  addCssVariables
} from '@/store/utils/config'

export const getConfigState = () => {
  return {
    global: {
      color: {
        // values set with null will be automatically set based on some other variable if configured to do so (see CssVariableVariations.js)
        // If some value is present the specified value will take preference
        primary: '#130E37',
        primaryLight: null,
        primaryDisabled: null
      }
    },
    button: {
      template: '{label} {price}',
      animation: null,
      events: {},
      label: getI18nProperties(null),
      spinnerVisible: false,
      disabled: false
    },
    fields: {
      error: {
        animation: 'shake' // or null to disable it
      },
      icons: {
        regular: {
          ...getFieldsProperties(null, false)
        },
        error: {
          ...getFieldsProperties(null, false)
        },
        help: {
          pan: null,
          securityCode: null
        },
        miscellaneous: {
          caret: null
        },
        delete: null
      },
      custom: {
        template: '',
        events: {}
      },
      checkbox: {
        type: 'default',
        template: '',
        events: {}
      },
      events: {},
      ...getFieldsProperties(fieldStyle, false)
    },
    events: {},
    merchant: {
      header: {
        image: {
          type: 'logo',
          src: 'data:image/svg+xml;base64,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',
          backgroundColor: null,
          visibility: true
        },
        shopName: {
          label: null,
          color: '#FFF',
          visibility: true,
          gradient: false,
          borderBottom: '1px solid var(--kr-global-color-primary)'
        },
        orderId: {
          color: '#FFF',
          visibility: true
        },
        amount: {
          color: 'var(--kr-global-color-primary)',
          visibility: true
        },
        backgroundColor: '#AAA'
      }
    },
    form: {
      brand: {
        visibility: true
      },
      button: {
        color: '',
        backgroundColor: '',
        borderColor: '',
        disabled: {
          color: '',
          backgroundColor: '',
          borderColor: ''
        },
        visibility: true
      },
      labels: {
        content: '',
        ...getFieldsProperties(getI18nProperties(null), false)
      },
      placeholders: {
        ...getFieldsProperties(getI18nProperties(null), true)
      },
      placeholdersMinWidth: {
        ...getFieldsProperties(null, true)
      },
      contentLabels: {
        ...getContentLabelFields(getI18nProperties(null))
      },
      error: {
        extra: {
          content: ''
        }
      },
      fields: {
        displayed: ['pan', 'expiryDate', 'securityCode'],
        order: []
      },
      controls: {
        order: []
      },
      layout: 'inherit', // compact | column
      wrapper: false,
      redirection: {
        backgroundColor: null,
        border: null,
        borderTop: null,
        borderRight: null,
        borderBottom: null,
        borderLeft: null,
        borderRadius: null,
        boxShadow:
          'rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px',
        padding: null,
        margin: null,
        header: {
          height: '30px',
          backgroundColor: '#f5f5f5',
          border: null,
          borderTop: null,
          borderRight: null,
          borderBottom: '1px solid #CCC',
          borderLeft: null,
          borderRadius: null,
          padding: null,
          margin: null,
          boxShadow: null,
          logo: {
            type: 'regular',
            width: '19px',
            height: '20px',
            fill: '#808080',
            backgroundColor: null,
            border: null,
            borderTop: null,
            borderRight: null,
            borderBottom: null,
            borderLeft: null,
            borderRadius: null,
            padding: null,
            margin: null,
            order: '1', // 1..3
            visibility: 'visible'
          },
          label: {
            width: null,
            height: null,
            fontFamily: null,
            fontSize: null,
            fontWeight: null,
            color: null,
            order: '2', // 1..3
            visibility: 'visible'
          },
          closeBtn: {
            width: null,
            height: null,
            fill: '#808080',
            backgroundColor: null,
            border: '2px solid #808080',
            borderTop: null,
            borderRight: null,
            borderBottom: null,
            borderLeft: null,
            borderRadius: '50%',
            padding: '1px',
            margin: null,
            order: '3', // 1..3
            visibility: 'visible',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }
        },
        fullscreen: {
          header: {
            height: '37px'
          }
        }
      },
      popin: {
        button: true,
        footer: {
          logo: {
            visibility: true,
            default: whiteLabelMap.default.logo
          }
        }
      },
      smartButton: {
        button: {
          spinnerVisible: false,
          $hover: {
            border: null
          }
        }
      },
      smartform: {
        width: '', // Needs to be empty string to support legacy. See: KJS-5401
        overlay: {
          logo: {
            visibility: false,
            file: null
          },
          // used by KR.overlay -> show(), hide(), default()
          // This property will override the default overlay showing logic
          forcedDisplayState: null
        },
        size: {
          thresholds: {
            S: 350,
            M: 450,
            L: 500
          }
        },
        supported: true,
        methodLabel: {
          flashDuration: 0.8
        },
        modal: {
          borderTop: '0px',
          borderBottom: '0px',
          backButton: {
            height: '18px',
            $redirect: {
              height: '0px'
            }
          }
        },
        embedded: {
          header: {
            visibility: true,
            borderBottom: null,
            amount: {
              figure: {
                color: null
              }
            }
          },
          button: {
            $hover: {
              border: null
            }
          }
        },
        singlePaymentButton: {
          visibility: true
        },
        radioButton: {
          visibility: false
        },
        nestedMethod: {
          animationDuration: '0.3s'
        }
      }
    },
    popin: {},
    theme: {
      name: ''
    }
  }
}

export const configActions = $locator => {
  return {
    parseCssConfig({ state, getters }) {
      // Get all the css variables from the store
      const variables = {}
      Object.keys(getConfigState()).forEach(key => {
        getCssVariables(state[key], `--kr-${key}`, variables)
      })

      addCssVariables(variables, getters.getValueFromCssVar)
    },
    setCustomButtonLabel({ commit }, value) {
      commit('UPDATE', { button: { label: getI18nProperties(value) } })
    }
  }
}

export const configGetters = {
  isSmartFormSupported: ({
    form: {
      smartform: { supported }
    }
  }) => !!supported,
  isCompactCardForm: ({
    form: { layout: cardFormLayout },
    smartForm: { layout: smartFormLayout }
  }) => {
    return (
      cardFormLayout === 'compact' ||
      (cardFormLayout === 'inherit' &&
        ['compact', 'grid'].includes(smartFormLayout))
    )
  },
  hasCustomOrder({
    form: {
      fields: { order }
    }
  }) {
    return order.length > 0
  },
  getValueFromCssVar(state) {
    return varName => {
      varName = varName.replace('--kr-', '')
      const value = varName.split('-').reduce((prev, curr) => prev[curr], state)
      return value
    }
  }
}
